module.exports = __webpack_public_path__ + "static/media/mail.d29aa413.svg";